import type { CarrierPrice } from "~/shared/schemas/carrier-schema";
import { formatCurrency } from "~/shared/utils/string-fns.ts";

export const getLiabilityText = (
	selectedCarrier: CarrierPrice,
): string | null => {
	const { maxLiabilityOverride, maxLiabilityNew, maxLiabilityUsed } =
		selectedCarrier;

	if (maxLiabilityOverride && maxLiabilityOverride > 0) {
		return formatCurrency(maxLiabilityOverride);
	}

	if (maxLiabilityNew && maxLiabilityUsed) {
		return `${formatCurrency(maxLiabilityNew)} / ${formatCurrency(maxLiabilityUsed)}`;
	}

	return null;
};

type LiabilityDisplayProps = {
	selectedCarrier?: CarrierPrice | null;
};

export const LiabilityDisplay = ({
	selectedCarrier,
}: LiabilityDisplayProps) => {
	if (!selectedCarrier) return null;

	const liabilityText = getLiabilityText(selectedCarrier);
	if (!liabilityText) return null;

	return (
		<div>
			<strong>Liability:&nbsp;</strong>
			{liabilityText}
		</div>
	);
};
